import { useParams, useNavigate } from "react-router-dom";
import { Lightning, ArrowLeft } from "@phosphor-icons/react";
import { useFeatureFlags } from "@/lib/featureFlags";

// Phase 0 scaffolding: a parallel, dormant WebRTC "direct streaming" session view.
// It does NOT stream yet and is not linked from anywhere in the live UI. When the flag is
// off it simply points back to the working relay session, so it can never break anything.
export default function SessionRTC() {
  const { machineId } = useParams();
  const navigate = useNavigate();
  const { flags, loaded } = useFeatureFlags();
  const enabled = !!flags.webrtc_enabled;

  return (
    <div data-testid="session-rtc-page" className="min-h-screen bg-background text-foreground flex items-center justify-center px-5">
      <div className="max-w-md w-full rounded-2xl border border-white/10 bg-card/60 p-8 text-center">
        <div className="w-12 h-12 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center mx-auto mb-5">
          <Lightning size={24} weight="duotone" className="text-primary" />
        </div>
        <h1 className="font-heading text-2xl font-bold tracking-tight">Direct streaming (beta)</h1>
        <p className="mt-3 text-sm text-muted-foreground leading-relaxed" data-testid="session-rtc-status">
          {!loaded
            ? "Checking availability…"
            : enabled
              ? "WebRTC direct streaming is enabled but not implemented yet — this is the Phase 0 placeholder. Your sessions still run on the standard secure relay."
              : "WebRTC direct streaming isn't turned on. Use the standard secure relay session below."}
        </p>
        <button
          data-testid="session-rtc-use-relay"
          onClick={() => navigate(`/session/${machineId}`)}
          className="mt-6 inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground font-semibold px-6 py-3 hover:scale-[1.04] transition-transform"
        >
          <ArrowLeft size={16} weight="bold" /> Open standard session
        </button>
      </div>
    </div>
  );
}
